import React from 'react';
import { Select } from '@buildoutinc/blueprint-react/ui/Select';

type Value = string | number;

interface Option {
  label: string;
  value: Value;
}

interface Props {
  ariaLabel: string;
  checkAllIfNone?: boolean;
  label: string;
  options: Option[];
  selected: Value[];
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function FilterSelect({ ariaLabel, checkAllIfNone, label, options, selected, onChange }: Props) {
  const allChecked = checkAllIfNone && selected.length === 0;
  const checkedValues = allChecked ? options.map(option => option.value) : selected;

  const handleValueChange = (nextValues: Value[]) => {
    const value = [...checkedValues, ...nextValues].find(v => checkedValues.includes(v) !== nextValues.includes(v));
    if (value === undefined) return;

    const target = { value, checked: allChecked || nextValues.includes(value) };
    onChange({ target } as unknown as React.ChangeEvent<HTMLInputElement>);
  };

  return (
    <Select multiple value={checkedValues} onValueChange={handleValueChange}>
      <Select.Trigger aria-label={ariaLabel} className="w-auto gap-2">
        <Select.Value>{label}</Select.Value>
      </Select.Trigger>
      <Select.Content alignItemWithTrigger={false} className="ds-filter-select-content">
        {options.map(option => (
          <Select.Item key={option.value} value={option.value}>{option.label}</Select.Item>
        ))}
      </Select.Content>
    </Select>
  );
}
